import UsuarioSistemaGrid from "components/Elements/UsuarioSistemaGrid";
import React from "react";
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
 } from "react-bootstrap";
 import { useNavigate} from 'react-router-dom';
 import { useUsuarioSistema } from '../hooks/useUsuarioSistema';

function ListarUsuariosSistema(Usuario) {
  let navigate = useNavigate();
  let usuario=Usuario.usuarioActual.Usuario;
  const usuarioActualSistema = useUsuarioSistema({Usuario:usuario,Genero:'F',CargoId:1});
  const usuarioActual=usuarioActualSistema?.usuarioSistema;
    return (
      <>
        <Container fluid>
          
        <Row>
            <Col md="12">
              <Card className="strpied-tabled-with-hover">
                <Card.Header>
                  <Card.Title as="h4">Listado de usuarios</Card.Title>
                  <p className="card-category">
                    En esta sección puede habilitar nuevos usuarios o darlos de baja
                  </p>
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
                <div className="button-container mr-auto ml-auto">
                {usuarioActual?.Roles?.includes(1) || usuarioActual?.Roles?.includes(2)?
                <Button
                  className="btn-fill pull-right ml-2"
                  type="info"
                  variant="info"
                  onClick={ ()=>
                    navigate('/admin/CrearUsuarioSistema')
                  }
                  >Crear Usuario Sistema</Button>
                  :null
                  }
                  </div>
                  <UsuarioSistemaGrid></UsuarioSistemaGrid>
                  
                </Card.Body>
              </Card>
            </Col>
        </Row>
        
        </Container>
      </>
    );
  
  
}

export default ListarUsuariosSistema;
